import { CombinedFilter } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';

import { map } from 'rxjs';
import get from 'lodash-es/get';
import { format, parseISO } from 'date-fns';
import { ExportStoreService } from '../export-overlay.store';
import { ExportFileFormat, ExportRange } from './core/export-task.enum';
import { LegacyExportTask } from './core/export-task-legacy';
import OrderPaymentAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/process/order-payment/order-payment.entity';
import { OrderPaymentAService } from 'app/modules/components/reports/historic/order-payment/order-payment.service';
import { user } from 'app/mock-api/common/user/data';


//This is done in his component



/** This class is instantiated by a factory (see ExportService).
 * The base ExportTask class takes care of all the functionality of the
 * task, like the current page, the progress and the status of the
 * task. */
export class OrderPaymentExport extends LegacyExportTask {
    constructor(
        itemCount: number,
        initialFilter: CombinedFilter<OrderPaymentAttributes>,
        range: ExportRange,
        format: ExportFileFormat,
        store: ExportStoreService,
        private orderpaymentService: OrderPaymentAService,
    ) {
        super('order-payment', 'Cobranza', itemCount, range, format, initialFilter, store);
    }

    private transformObject(item: OrderPaymentAttributes) {
        return {
            route: get(item, 'subRoute.name', '??'),
            user: get(item, 'user.user_login.username', '??'),
            shipToName: get(item, 'shipTo.name', '??'),
            serial: get(item, 'serials', '??'),
            paymentType: get(item, 'paymentType.name', '??'),
            date: get(item, 'dateHour', '??'),
            bankOperationNumber: get(item, 'bankOperationNumber', '??'),
            bank: get(item, 'bank.name', '??'),
            operationNumber: get(item, 'operationNumber', '??'),
            paying: get(item, 'paying', '??'),
            amount: get(item, 'amount', '??'),
        };
    }

    /** Better header text for excel and csv */
    private transformObjectAsNatural(item: OrderPaymentAttributes) {
        return {
            "Ruta": get(item, 'subRoute.name', '??'),
            "Usuario": get(item, 'user.user_login.username', '??'),
            "Socio de Negocio": get(item, 'shipTo.name', '??'),
            "Documento":  get(item, 'serials', '??'),
            "Tipo/Método Pago": get(item, 'paymentType.name', '??'),
            "Fecha": this.formatDate(get(item, 'dateHour', '??') as string, true),
            "Nro. Letra": get(item, 'bankOperationNumber', '??'),
            "Banco":  get(item, 'bank.name', '??'),
            "Operación":  get(item, 'operationNumber', '??'),
            "Abono":  get(item, 'paying', '??'),
            "Pago Total":  get(item, 'amount', '??'),
        };
    }

    private formatDate(dateString: string, includeTime: boolean = false): string {
        if (dateString === '??') return dateString;
        const dateFormat = includeTime ? "dd/MM/yyyy hh:mm a" : "dd/MM/yyyy";
        return format(parseISO(dateString), dateFormat);
    }

    /** The main method of the export task class. Called for each page. Here do the request, process
     * and transform the data. The result for each request after processed must be an object array,
     * this object array will be later transformed to a file (xlsx, csv, json) automatically. */
    override onRequest(currentFilter: CombinedFilter<OrderPaymentAttributes>) {
        // To avoid displaying the global loading screen, the header x-ave-ctx is sent with the request,
        // the http interceptor finds that the header is set as 'export' and ignores the request, so
        // won't display the loading screen.
        return this.orderpaymentService.findByFilter(currentFilter, { contextHeader: 'export' }).pipe(
            map((response) => {
                if (this.format === ExportFileFormat.JSON) {
                    return get(response, 'data.0.data', []).map((item) => this.transformObject(item));
                }
                return get(response, 'data.0.data', []).map((item) => this.transformObjectAsNatural(item));
            }),
        );
    }
}